import { BaseEntity } from "../common/baseEntity";
import { Group } from "../groups/group";
import { Company } from "./company";
import { UserFlag } from "./userFlag";
import { Order } from "../orders/order";
import { OrderViewType } from "../management/order/orderViewType";
import { Component } from "../components/component";

export class User extends BaseEntity<number> {

    Email: string;
    UserName: string;
    FullName: string;
    FirstName: string;
    LastName: string;
    IsPasswordEmpty: boolean;
    ImageSrc: string;
    CoverImageURI: string;
    Company: Array<Company>;
    Groups: Array<Group> = [];
    Flag: UserFlag = UserFlag.Default;
    Phone: number;
    Position: string;
    public OrderIDs: Array<number> = [];
    public Orders: Array<Order> = new Array<Order>();

    public constructor(obj?: Partial<User>) {
        super();

        if (obj != null)
            Object.assign(this, obj);
    }

}

export class OrderManagementConfig {
    public ViewType: OrderViewType;
    public ColumnsConfigs: ColumnsConfig[];
    public Id: number;

    constructor(obj?: Partial<OrderManagementConfig>) {
        if (obj)
            Object.assign(this, obj);
    }
}

export class ColumnsConfig {
    public Type: OrderViewType;
    public Columns: Column[] = [];

    constructor(obj?: Partial<ColumnsConfig>) {
        Object.assign(this, obj);
    }
}

export class Column {
    public Index: number;
    public Name: string;
    public Property: string;
    public SortType: SortType;
    public IsSelected: boolean;
    public RefId: number;

    constructor(obj?: Partial<Column>) {
        Object.assign(this, obj);
    }
}

export class UserViewConfig {
    public Id?: number = null;
    public UserId: number;
    public ComponentId: Component;
    public ViewType: OrderViewType;

    constructor(obj?: Partial<UserViewConfig>) {
        Object.assign(this, obj);
    }
}

export enum SortType {
    None = 0,
    Asc = 1,
    Desc =2
}


// WEBPACK FOOTER //
// ./app/objects/users/user.ts